"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _recoil = require("recoil");

var _store = require("../store");

// import React from 'react'
var useSearchQuery = function useSearchQuery() {
  var _useRecoilState = (0, _recoil.useRecoilState)(_store.searchState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 2),
      search = _useRecoilState2[0],
      setSearchState = _useRecoilState2[1];

  var setSearchQuery = function setSearchQuery(value, type) {
    var searchInType = ['free-images', 'author'].indexOf(type) === -1 ? 'free-images' : type;
    setSearchState({
      query: value,
      type: searchInType
    });
  };

  return {
    search: search,
    setSearchQuery: setSearchQuery
  };
};

var _default = useSearchQuery;
exports["default"] = _default;